export default __webpack_public_path__ + "static/media/protocol-2.ba42aa64.png";